// removed by extract-text-webpack-plugin
module.exports = {"root":"_Uab6v","icon":"_3Ntmq","tagBlock":"_28BiR","tag":"_C0oTK"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Post/components/PostContent/components/ContentBlock/components/TagBlock/TagBlock.scss
// module id = 1164
// module chunks = 2